import React from 'react'
import BlockContent from '@sanity/block-content-to-react'

import { queryConfig } from 'utls/queryConfig.js'
import Newsletter from 'modules/newsletter.js'

export const serializer = {
  types: {
    block: props => {
      const style = props.node.style || 'normal'
      if (/^h\d/.test(style)) {
        switch (style) {
          case 'h3':
            return <h3 className='mb0 mt0 pb0'>{props.children}</h3>
          default:
            return
        }
      }
      return style === 'blockquote' ? (
        <blockquote>{props.children}</blockquote>
      ) : (
        <p>{props.children}</p>
      )
    }
  },
}

const ComingSoon = () => {
  const data = queryConfig()
  return (
    <div className='x bct coming__soon'>
      <div className='container--xl ma f jcb fw coming__soon-wrap rel'>
        <div className='ac p15 x f jcc aic'>
          <div>
            <h5 className='caps mb05'>{data.comingSoonTitle}</h5>
            <span className='h3 coming__soon-force mb05 block'>{data.comingSoon}</span>
          </div>
        </div>
        <div className='ac p15 mb1 x coming__soon-form f jcc aic'>
          <div>
            <BlockContent blocks={data.title} serializers={serializer} />
            <div className='mt1'>
              <Newsletter placeholder={`Your Email`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComingSoon